// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LMKC","placeholdersHeader":"styles_placeholdersHeader__3QehE","editorStyle":"styles_editorStyle__ZLwZW","placeholdersBox":"styles_placeholdersBox__1SVHM"};